import AxiosBase from "@/assets/js/axios-base";
import Axios from "@/assets/js/axios";

let axiosBase = new AxiosBase();
let $axios = Axios.http;

const state = {
  prefectureList: []
};

const getters = {};

const actions = {
  fetchAll({ commit, state }) {
    $axios.get(axiosBase.getUrls().getAllPrefectures).then(value => {
      commit("writeAllData", value.data.data);
    });
  }
};

const mutations = {
  writeAllData(state, data) {
    state.prefectureList = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
